import { render, staticRenderFns } from "./FormRatingDefault.vue?vue&type=template&id=7137b5b8&"
import script from "./FormRatingDefault.vue?vue&type=script&lang=js&"
export * from "./FormRatingDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports